import { render, staticRenderFns } from "./DocumentHeader.vue?vue&type=template&id=1dbaef52&scoped=true"
import script from "./DocumentHeader.vue?vue&type=script&lang=ts"
export * from "./DocumentHeader.vue?vue&type=script&lang=ts"
import style0 from "./DocumentHeader.vue?vue&type=style&index=0&id=1dbaef52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbaef52",
  null
  
)

export default component.exports